module.exports = __webpack_public_path__ + "img/309.270ed9cb.jpg";